<template>
  <EmdFormGroup
    :label="$t('mother-name')"
    required
    :state="getState($v.recipient.mother_name)"
    :feedbacks="feedbacks($v.recipient.mother_name)"
  >
    <EmdInput
      @input="() => $v.recipient.mother_name.$touch()"
      v-model="recipient.mother_name"
      name="mother_name"
      :readonly="disabled"
      :disabled="disabled"
    />
  </EmdFormGroup>
</template>

<script>
import { EmdFormGroup, EmdInput } from 'emerald-vue/src/components'
import { getState, feedbacks } from '@/utils/form.utils'
import { managingPartners } from '../validations'
export default {
  name: 'MotherNameInput',
  components: {
    EmdFormGroup,
    EmdInput
  },
  data: () => ({
    getState,
    feedbacks,
    mother_name: ''
  }),
  props: {
    recipient: {
      type: Object
    },
    disabled: {
      type: Boolean
    }
  },
  validations () {
    return { recipient: managingPartners }
  }
}
</script>
<i18n>
  {
    "pt-BR":{
      "mother-name": "Nome da mãe"
    },
    "en-US":{
      "mother-name": "Mother's Name"
    }
  }
</i18n>
